module.exports = __webpack_public_path__ + "img/yxlogo_white.04f4b776.png";